import { Button, message, Modal, notification, Table } from "antd";
import React, { useState } from "react";
import { useApi } from "../../../../../hooks/http2";
import { displayTotal } from "../../../../../utils/helper";
import dayjs from "dayjs";
import { STATUS } from "../constants/status.constant";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { primary } from "../../../../../themes/colors";
import { axios } from "../../../../../utils/useAxios";
import { useHardPromotionFormMutate } from "../contexts/hard-promotion-form.context";
import _ from "lodash";

const ModalClone = () => {
  const {
    state: {
      data: { items },
      modal,
    },
    dispatch,
  } = useHardPromotionFormMutate();
  const [loading, setLoading] = useState(false);

  const promotion = useApi(
    {
      url: `/marketing/hard-promotion`,
      token: true,
    },
    []
  );

  const handleClone = async (id) => {
    try {
      setLoading(true);
      const { data } = await axios.get(
        `/marketing/hard-promotion/${id}/clone`,
        {
          params: { item_type: "items" },
        }
      );

      if (data?.length > 0) {
        for (let i = 0; i < data.length; i++) {
          const current = data[i];

          if (
            _.find(items || [], (n) => n.product_code === current.product_code)
          ) {
            notification.warning({
              message: `ไม่สามารถเพิ่มสินค้าได้`,
              description: `มีสินค้า ${current.product_code} ในรายการแล้ว`,
            });
            continue;
          }
          dispatch({
            type: "ADD_ITEM",
            payload: {
              type: "items",
              product_code: current.product_code,
              product_name: current.product_name,
              qty: current.qty,
            },
          });
        }
      }

      message.success("คัดลอกสินค้าเรียบร้อย");
      setLoading(false);
      handleClose();
    } catch (error) {
      message.error("ไม่สามารถทำการคัดลอกได้");
      setLoading(false);
    }
  };

  const handleClose = () => dispatch({ type: "CLOSE_MODAL" });

  return (
    <Modal
      visible={modal.name === "clone"}
      title="คัดลอกรายการสินค้าจากโปรโมชันอื่น"
      width={800}
      style={{ maxWidth: "90%" }}
      footer={false}
      maskClosable={!loading}
      onCancel={() => {
        if (!loading) handleClose();
      }}
    >
      <Table
        bordered
        size="small"
        loading={promotion.loading}
        dataSource={promotion.fetch?.list || []}
        rowKey={"id"}
        pagination={{
          size: "default",
          total: promotion.fetch?.total || 0,
          showLessItems: true,
          showTotal: displayTotal,
        }}
      >
        <Table.Column key="code" title="รหัส" dataIndex="code" align="center" />
        <Table.Column key="name" title="ชื่อโปรโมชัน" dataIndex="name" />
        <Table.Column
          key="promotion_date"
          title="โปรโมชันมีผลวันที่"
          dataIndex="start_date"
          align="center"
          render={(start_date, { end_date }) =>
            `${dayjs(start_date).format("DD/MM/YYYY")} - ${dayjs(
              end_date
            ).format("DD/MM/YYYY")}`
          }
        />
        <Table.Column
          key="status"
          title="แสดงผล"
          dataIndex="status"
          align="center"
          render={(status) => {
            const is_active = status === STATUS.ACTIVE;
            return is_active ? (
              <FaCheckCircle color={primary[500]} />
            ) : (
              <FaTimesCircle color="red" />
            );
          }}
        />
        <Table.Column
          key="action"
          // title={<FaCogs />}
          dataIndex="id"
          align="center"
          render={(id) => (
            <Button
              size="small"
              type="primary"
              ghost
              onClick={() => handleClone(id)}
              loading={loading}
            >
              คัดลอก
            </Button>
          )}
        />
      </Table>
    </Modal>
  );
};

export default ModalClone;
